import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import { strategy as applicableEntityStrategy } from "../constants/applicableEntity.constant";
import { FeeTemplateData } from "../types/feeTemplates.type";
import Button from "../../../common/components/Button";

export class FeeTemplatesTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (feeTemplates: FeeTemplateData[]) => {
      return feeTemplates.map((feeTemplate) => ({
        ...feeTemplate,
        updated_at: (new Date(feeTemplate.updated_at)).toLocaleDateString('pt-br'),
        applicable_entity: applicableEntityStrategy[feeTemplate.applicable_entity as keyof typeof applicableEntityStrategy],
        actions: <Link to={`/fee-templates/${feeTemplate.id}`}>
          <Button name="access_fee_templates_list" className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
            <ArrowBigRight />
          </Button>
        </Link>
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (feeTemplates: FeeTemplateData[]) => {
      return feeTemplates.map((feeTemplate) => ({
        route: `/fee-templates/${feeTemplate.id}`,
        items: [
          ['Tipo', applicableEntityStrategy[feeTemplate.applicable_entity as keyof typeof applicableEntityStrategy]],
          ['Nome', feeTemplate.display_name],
        ]
      }));
    };
  }
}
